import * as React from 'react';
import { clsx } from 'clsx';
import { devUseWarning } from '../_util/warning';
import { ConfigContext } from '../config-provider';
import { useToken } from '../theme/internal';
export const GroupSizeContext = React.createContext(undefined);
const ButtonGroup = (props) => {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, size, className, ...others } = props;
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = useToken();
    const sizeCls = React.useMemo(() => {
        switch (size) {
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [size]);
    if (process.env.NODE_ENV !== 'production') {
        const warning = devUseWarning('Button.Group');
        warning.deprecated(false, 'Button.Group', 'Space.Compact');
        warning(!size || ['large', 'medium', 'small'].includes(size), 'usage', 'Invalid prop `size`.');
    }
    const classes = clsx(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl',
    }, className, hashId);
    return (React.createElement(GroupSizeContext.Provider, { value: size },
        React.createElement("div", { ...others, className: classes })));
};
export default ButtonGroup;
